<template>
  <div>
    <div class="row bg-dark rounded">
      <div class="col-12 text-center pt-2 bg-primary">
        <router-link :to="{path:'/invoices/new-company',query: client}">
          <h5 class="text-white">{{client.name}}</h5>
        </router-link>
      </div>
      <div class="col-12">
        <b-form-checkbox v-model="inputEAN" size="lg" name="check-button" class="text-left mt-1" switch>
          {{ inputEAN ? 'EAN' : 'SKU' }}
        </b-form-checkbox>
      </div>
      <div class="mb-3 input-group">
        <div class="col-5 mt-2">
          <input v-if="inputEAN" v-model="req.ean" v-on:keyup.enter="addArticle" type="text" autocomplete="off" placeholder="SCAN EAN" class="form-control" style="font-size:1.43rem" required>
          <input v-else v-model="req.sku" v-on:keyup.enter="addArticle" type="text" autocomplete="off" placeholder="ENTER SKU" class="form-control" style="font-size:1.43rem" required>
        </div>
        <div class="col-1" style="margin-left:-2.3rem; margin-top: 8px">
          <b-button @click="addArticle" size="lg" block squared><b-icon-plus></b-icon-plus></b-button>
        </div>
        <div class="col-4 d-inline-block text-center">
          <div class="plate" style="margin-top: -4px">
            <input v-model="req.plate" maxlength="7" type="text" name="number" id="plate" autocomplete="off" placeholder="Reg">
          </div>
        </div>
        <div class="col-2 text-right">
          <button @click="closeInvoice" class="btn btn-success p-3 rounded">CLOSE INVOICE</button>
        </div>
      </div>
    </div>

    <div v-if="pending.length" class="row position-relative">
      <div class="w-100 mt-3 overflow-hidden text-center">
        <h3> Pending items</h3>
      </div>

      <div class="w-100 mt-3 overflow-hidden rounded">
        <table class="table">
          <thead>
          <tr>
            <th scope="col">SKU</th>
            <th scope="col">Name</th>
            <th scope="col">Reg</th>
            <th scope="col">Price</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">QTT</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Location</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Order</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, i) in pending" v-bind:key="i" class="pointer" :style="[selectedForPrint(row) ? {background: '#007bff'} : {}]">
            <th scope="row">{{row.sku}}</th>
            <td @click="addForPrint(row)">{{row.name || "No name"}}</td>
            <td>{{row.plate || "/"}}</td>
            <td>{{row.price || 0}} kr</td>
            <td class="d-none d-sm-table-cell text-center">
              <b-icon-dash v-if="!row.custom" @click="adjustCount(row._id, -1)" class="pointer"></b-icon-dash>
              {{row.qtt}}
              <b-icon-plus v-if="!row.custom" @click="adjustCount(row._id, 1)" class="pointer"></b-icon-plus>
              <b-icon-trash v-else @click="removeCustom(row._id)"></b-icon-trash>
            </td>
            <td class="d-none d-sm-table-cell text-center">{{row.location || '/'}}</td>
            <td class="d-none d-sm-table-cell text-center align-middle border-start">
              <b-icon-dash @click="decrementToOrder(row)" class="pointer"></b-icon-dash>
              {{inlineQ[row.sku] || 0}}
              <b-icon-plus @click="incrementToOrder(row)" class="pointer"></b-icon-plus>
              <button @click="orderArticle(row.sku, inlineQ[row.sku])" class="ml-2 btn btn-outline-light">
                <b-icon icon="download"></b-icon>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="!showCustom" class="row">
      <div class="w-100 mt-3 text-right">
        <button v-if="Object.keys(selectedItems).length > 0" class="btn btn-sm pointer mr-3 btn-primary" @click="printProductList">PRINT</button>
        <button class="btn btn-sm btn-light pointer" @click="showCustom = true">Add Custom Item</button>
      </div>
    </div>

    <div v-if="!loading && showCustom" class="row">
      <div class="inline mt-3">
        <label class="" for="sku">SKU</label>
        <input v-model="form.sku" type="text" id="sku" class="bg-dark rounded ml-1 custom-input">
        <label class="ml-3" for="name">Name</label>
        <input v-model="form.name" type="text" id="name" class="bg-dark rounded ml-1 custom-input">
        <label class="ml-3" for="price">Price</label>
        <input v-model="form.price" type="number" id="price" class="bg-dark rounded p-1 ml-1 custom-input" style="width: 10%">
        <label class="ml-3" for="price">Qtt</label>
        <input v-model.number="form.qtt" type="number" id="qtt" class="bg-dark rounded p-1 ml-1 custom-input" style="width: 10%">
        <button @click="onSubmit" class="btn btn-sm btn-primary block ml-5" style="width: 120px">Save</button>
      </div>
    </div>

    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>

    <div class="row" v-if="pastInvoices.length">
      <div class="w-100 mt-3 overflow-hidden text-center">
       <h3> Past Invoices</h3>
      </div>
      <div class="w-100 mt-3 overflow-hidden rounded">
        <table class="table">
          <thead>
          <tr>
            <th scope="col">Date</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Number</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Value</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Status</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Excel</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, i) in pastInvoices" v-bind:key="i" class="pointer">
            <th @click="renderInvoice(row)" scope="row">{{moment(row.createdAt).format('DD.MM.yyyy HH:mm')}}</th>
            <td class="d-none d-sm-table-cell text-center">{{row.number}}</td>
            <td class="d-none d-sm-table-cell text-center">{{row.items.reduce((value, item) => value += item.qtt * item.price, 0).toFixed(2)}} kr</td>
            <td v-if="row.canceled" class="d-none d-sm-table-cell text-center text-danger">
              <b-button @click="getTripletexInvoice(row.kreditNote ? row.kreditNote : row.ttexId)">KREDITNOTA</b-button>
            </td>
            <td v-else class="d-none d-sm-table-cell text-center text-success">
              <b-button variant="success" @click="cancelInvoice(row._id, row.ttexId)">{{row.paid ? 'PAID POS' : 'TRIPLETEX'}}</b-button>
            </td>
            <td class="d-none d-sm-table-cell text-center">
              <b-button variant="info" @click="getExcelFile(row)">File</b-button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pack-list :client="client.name" :print-items="selectedItems"></pack-list>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import fixed from '@/fixed';
import PackList from '@/components/PackList.vue';

const API_URL = `${fixed.API_URL}/admin`;

export default {
  components: { PackList },
  data: () => ({
    loading: false,
    showCustom: false,
    inputEAN: false,
    inlineQ: {},
    req: {
      clientId: '',
      plate: '',
      sku: '',
      ean: '',
    },
    client: {},
    pending: [],
    pastInvoices: [],

    form: {
      sku: '',
      name: '',
      price: 0.00,
      clientId: '',

      qtt: 1,
      invoiced: false,
      custom: true,
    },
    selectedItems: {},

    moment,
  }),
  async mounted() {
    this.req.clientId = this.$route.params.id;
    try {
      const { data } = await axios.get(`${API_URL}/client-info`, { withCredentials: true, params: { client: this.req.clientId } });
      this.client = data;
    } catch (err) {
      this.$toast.error('can\'t fetch client info');
    }
    await Promise.all([this.getPending(), this.getPastInvoices()]);
  },
  watch: {
    inputEAN: {
      handler(ean) {
        if (ean) {
          this.req.sku = '';
        } else {
          this.req.ean = '';
        }
      },
    },
  },
  methods: {
    async getPending() {
      try {
        const { data } = await axios.get(`${API_URL}/list-pending`, { withCredentials: true, params: { client: this.req.clientId } });
        this.pending = data || [];
      } catch (err) {
        this.$toast.error('can\'t fetch pending articles');
      }
    },
    async getPastInvoices() {
      this.loading = true;
      try {
        const { data } = await axios.get(`${API_URL}/client-invoices`, { withCredentials: true, params: { client: this.req.clientId } });
        this.pastInvoices = data || [];
      } catch (error) {
        this.$toast.error('can\'t fetch past invoices');
      }
      this.loading = false;
    },
    async getTripletexInvoice(id) {
      if (!id) return;

      this.loading = true;
      try {
        const { data } = await axios.get(`${fixed.API_URL}/admin/tripletex-invoice/${id}`, { withCredentials: true, responseType: 'arraybuffer' });
        const blob = new Blob([data], { type: 'application/pdf' });
        const blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      } catch (err) {
        this.$toast.error('can\'t get Tripletex invoice');
      }
      this.loading = false;
    },
    async addArticle() {
      if (!this.req.sku && !this.req.ean) return;
      this.req.plate = this.req.plate.toUpperCase();

      this.loading = true;
      try {
        const { data } = await axios.post(`${API_URL}/save-pending`, this.req, { withCredentials: true });
        this.$toast.success(`OK, LEFT ON STOCK: ${data}`);
        this.req.sku = '';
        this.req.ean = '';
        await this.getPending();
      } catch (err) {
        this.$toast.error(err?.response?.data || 'error while adding item to the client');
      }
      this.loading = false;
    },
    async adjustCount(_id, operator) {
      this.loading = true;
      try {
        const { data } = await axios.put(`${API_URL}/invoice-item-count`, { _id, operator }, { withCredentials: true });
        this.$toast.success(`OK, LEFT ON STOCK: ${data}`);
        await this.getPending();
      } catch (err) {
        this.$toast.error('can\'t change quantity');
      }
      this.loading = false;
    },
    async removeCustom(id) {
      this.loading = true;

      try {
        await axios.delete(`${API_URL}/remove-custom-pending/${id}`, { withCredentials: true });
        await this.getPending();
      } catch (error) {
        this.$toast.error("can't remove custom idem");
      }
      this.loading = false;
    },
    async closeInvoice() {
      const desc = prompt('Add inovice description if needed', ''); // eslint-disable-line

      this.loading = true;
      try {
        const { data } = await axios.get(`${API_URL}/invoice-pending`, { withCredentials: true, responseType: 'arraybuffer', params: { client: this.req.clientId, desc } });

        const blob = new Blob([data], { type: 'application/pdf' });
        const blobURL = URL.createObjectURL(blob);
        window.open(blobURL);

        await this.getPending();
        await this.getPastInvoices();
      } catch (err) {
        this.$toast.error('can\'t close the invoice');
      }
      this.loading = false;
    },
    async setAsPaid(id) {
      const ok = confirm('Are you sure you want to set this invoice as paid?'); // eslint-disable-line
      if (!ok) return;

      this.loading = true;
      try {
        await axios.put(`${API_URL}/invoice-state`, { _id: id, state: true }, { withCredentials: true });
        this.$toast.success('invoice state changed successfully');
        await this.getPastInvoices();
      } catch (err) {
        this.$toast.error('can\'t set invoice state');
      }
      this.loading = false;
    },
    async cancelInvoice(_id, ttexId) {
      const ok = confirm('Are you sure you want to cancel this invoice?'); // eslint-disable-line
      if (!ok) return;

      this.loading = true;
      try {
        await axios.put(`${API_URL}/cancel-invoice`, { _id, ttexId }, { withCredentials: true });
        this.$toast.success('successfully created kreditnote');
        await this.getPastInvoices();
      } catch (err) {
        this.$toast.error('can\'t cancel the invoice, check stock counts');
      }
      this.loading = false;
    },
    async renderInvoice(invoice) {
      this.loading = true;

      try {
        const { data } = await axios.post(`${API_URL}/otf-invoice`, invoice, { withCredentials: true, responseType: 'arraybuffer' });
        const blob = new Blob([data], { type: 'application/pdf' });
        const blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      } catch (err) {
        this.$toast.error('can\'t render invoice');
      }
      this.loading = false;
    },
    async getExcelFile(invoice) {
      this.loading = true;

      try {
        const response = await axios.post(`${fixed.API_URL}/admin/otf-excel`, invoice, { withCredentials: true, responseType: 'blob' });
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = invoice?.client?.name || 'price_analysis.xlsx';

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
      } catch (error) {
        this.$toast.error('can\'t download price analysis file');
      }

      this.loading = false;
    },
    async onSubmit(e) {
      e.preventDefault();

      this.form.clientId = this.$route.params.id;
      if (!this.form.clientId || !this.form.price) return;
      this.form.price = +(this.form.price);

      this.loading = true;
      try {
        await axios.post(`${API_URL}/custom-pending`, this.form, { withCredentials: true });
        this.$router.push({ name: 'client' });
      } catch (err) {
        this.$toast.error('error while saving custom item');
      }
      await this.getPending();
      this.loading = false;
      this.showCustom = false;
    },
    async orderArticle(sku, qtt) {
      if (qtt < 1 || !sku) return;

      this.loading = true;
      try {
        await axios.post(`${API_URL}/poland-order`, { sku, qtt, meta: 'WORKSHOP' }, { withCredentials: true });
        this.$toast.success('Article ordered successfully');
        this.inlineQ = {};
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.loading = false;
    },
    incrementToOrder(article) {
      if (!this.inlineQ[article.sku]) {
        this.inlineQ[article.sku] = 0;
      }
      this.inlineQ[article.sku] += 1;
      this.inlineQ = { ...this.inlineQ };
    },
    decrementToOrder(article) {
      if (!this.inlineQ[article.codename]) return;
      this.inlineQ[article.codename] -= 1;
    },
    addForPrint(item) {
      const key = `${item.sku}_${item.plate}`;
      if (this.selectedItems[key]) {
        this.$delete(this.selectedItems, key);
      } else {
        this.$set(this.selectedItems, key, item);
      }
    },
    selectedForPrint(item) {
      const key = `${item.sku}_${item.plate}`;
      return this.selectedItems[key];
    },
    printProductList() {
      window.print();
      this.selectedItems = {};
    },
  },
};
</script>

<style>
.custom-input {
  border: none;
  padding: 2px;
  color: white;
}
</style>
